<template>
  <div class="flex flex-col shadow-md rounded-md border-gray-300">
    <div class="px-4 flex flex-col justify-center relative h-48">
      <img
        class="absolute top-0 left-0 bottom-0 right-0 w-full h-full opacity-20 object-cover rounded-t-md"
        v-lazy-load data-src="~/assets/defaultProfessionTaskHero.jpg"
      />
      <JoszakiHeading class="first-letter:capitalize">
        {{ title }}
      </JoszakiHeading>
      <p class="md:text-xl font-bold">
        {{ $t("inspirations.landingDescription") }}
      </p>
    </div>
    <div
      class="bg-primary text-white px-4 py-4 flex flex-col justify-center rounded-b-md"
    >
      {{ $t("inspirations.landingHero") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "InspirationListPageHeader",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
